/**
 * Constants for Freeze V2 module.
 * Duplicated from freeze v1 so v2 has zero import dependencies on v1.
 */
export const TRANS_OVA_GENETICS_COMPANY_ID =
  '10000000-0000-0000-0000-000000000001';

export const hardcodedSites = [
  { label: 'MO - Missouri', value: '2' },
  { label: 'Main Farm', value: '1' },
  { label: 'MO - D5', value: '3' },
  { label: 'TOGU', value: '4' },
  { label: 'MAC to Main Farm', value: '6' },
  { label: 'MAC to TXP', value: '8' },
  { label: 'Incoming to WAC', value: '9' },
  { label: 'TXP to TX', value: '10' },
  { label: 'CRTXP to CA', value: '11' },
];

export const SLAUGHTER_HOUSE_SITES = ['CRIA', 'CRTX', 'CRWA', 'CRTXP'];

// Values are strings to match FreezeFormState.freezeDay (string | null) and the
// API contract (freezeDay is a String). A numeric value here silently breaks the
// trigger label, which matches on strict equality against the stored value.
export const FREEZE_DAY_OPTIONS = [
  { label: '6.5', value: '6.5' },
  { label: '7', value: '7' },
];

export const FIELD_NAMES = {
  NO_EMBRYOS_PRODUCED: 'noEmbryosProduced',
  CONTAMINANT_PRESENT: 'contaminantPresent',
  STAGE: 'stage',
  GRADE: 'grade',
  D65: 'd65',
  D7: 'd7',
  FREEZE_TIME: 'freezeTime',
  GRADER_65_NAME: 'grader65Name',
  GRADER_65_ID: 'grader65Id',
  GRADER_7_NAME: 'grader7Name',
  GRADER_7_ID: 'grader7Id',
  FREEZE_TECH_ID: 'freezeTechId',
  FREEZE_TECH_NAME: 'freezeTechName',
  LG: 'lowQuality',
  OWNER_ID: 'ownerId',
  PLATE: 'plateNumber',
  PREDICTION_TECH: 'predictedById',
  TT: 'tt',
  DC: 'discard',
  CLEAVED: 'cleaved',
  QUALITY: 'predictedGood',
  LOW: 'predictedVeryLow',
  HELD_FREEZE: 'heldAtTogToFreeze',
} as const;

export const EMBRYOS_PER_STRAW_VALUE = 1;
export const EMBRYOS_PER_VIT_STRAW_VALUE = 5;

export const BILL_ACCOUNT_CANING_OPTION = {
  NO_CHANGES: 100000000,
  GROUPS_OF_THREE: 100000001,
  ODDS_AND_EVENS: 100000002,
} as const;

export { DATE_PICKER_COMPACT as DATE_PICKER_MATCH } from '@/components/ui/date-picker-input';

export const MOBILE_BREAKPOINT = '(max-width: 768px)';
